var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.76 4.6626C22.8945 5.04636 21.9646 5.30572 20.9885 5.42241C21.9849 4.82522 22.7499 3.87955 23.1102 2.75279C22.163 3.31487 21.1267 3.71089 20.046 3.92374C19.1658 2.98597 17.9118 2.3999 16.5238 2.3999C13.8589 2.3999 11.6983 4.56043 11.6983 7.22518C11.6983 7.60343 11.741 7.97166 11.8232 8.32492C7.81288 8.12362 4.25732 6.20261 1.87729 3.28319C1.46202 3.99586 1.22406 4.82485 1.22406 5.70906C1.22406 7.3832 2.07602 8.86009 3.37072 9.72546C2.60444 9.70146 1.85501 9.4945 1.18502 9.12184C1.18474 9.14206 1.18474 9.16227 1.18474 9.18257C1.18474 11.5205 2.84805 13.4708 5.05543 13.9141C4.34486 14.1074 3.59952 14.1357 2.87634 13.9968C3.49034 15.9139 5.27244 17.3089 7.38392 17.348C5.73246 18.6421 3.65177 19.4136 1.39109 19.4136C1.00154 19.4136 0.617505 19.3907 0.23999 19.3462C2.37544 20.7153 4.91183 21.5141 7.63685 21.5141C16.5126 21.5141 21.3661 14.1613 21.3661 7.78479C21.3661 7.5755 21.3615 7.3674 21.3521 7.1605C22.2968 6.47758 23.1122 5.63171 23.76 4.6626",
    fill: "#55ACEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.dd468f352a29c8d474d4b7eb2b548e96.svg";
export { ForwardRef as ReactComponent };